/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbQuerySyncLogAction extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ServiceNowCmdbQuerySyncLogAction");
    }

    getFixupPrototypeFunction() { return ServiceNowCmdbQuerySyncLogAction.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbQuerySyncLogAction>): ServiceNowCmdbQuerySyncLogAction {
        let obj = Object.assign(new ServiceNowCmdbQuerySyncLogAction(), model);
        ServiceNowCmdbQuerySyncLogAction.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbQuerySyncLogAction>): ServiceNowCmdbQuerySyncLogAction {
        if (!model) return null;
        return ServiceNowCmdbQuerySyncLogAction.newInstance(<ServiceNowCmdbQuerySyncLogAction> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbQuerySyncLogAction) {
        if (!obj) return;

        models.ServiceNowCmdbQuerySyncLogAction.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbQuerySyncLogAction): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowCmdbQuerySyncLogAction.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of synchronization operation, which can be create, update, or delete
     */
    actions: Array<string>;

}
